import { Stack, StackItem } from '@optimus-web/core';
import { ShiftOverviewSection } from '../sections/ShiftOverviewSection';
import { ShiftTransactionsTable } from '../tables/shiftTransactions/ShiftTransactionsTable';

interface Props {
    cashierId: string;
}

export const ShiftOverviewPage = ({ cashierId }: Props) => (
    <Stack distribution="stretch" vertical spacing="500">
        <StackItem>
            <ShiftOverviewSection cashierId={cashierId} />
        </StackItem>
        <StackItem>
            <ShiftTransactionsTable cashierId={cashierId} />
        </StackItem>
    </Stack>
);
